<div  id="strength" #strength>  
 <ul id="strengthBar">  
 <li class="point" [style.background-color]="bar0"></li><li class="point" [style.background-color]="bar1"></li>
 <li class="point" [style.background-color]="bar2"></li><li class="point" [style.background-color]="bar3"></li>
 <li class="point" [style.background-color]="bar4"></li> 
 <!-- <span class="pl-5" *ngIf="this.idx==0">Weak</span>  -->
 <span class="strong pr-4 pl-4" *ngIf="this.idx==3">Strong</span>
 <span class="strong pr-4 pl-4" *ngIf="this.idx==4">Strong</span>
 <!-- <span class="pl-5" *ngIf="bar4 && !bar0 && !bar1 && !bar2 && !bar3">Strong</span> -->
      </ul>  
    </div>  